import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "redux/actions/auth";
import { showToast, TOAST_TYPE } from "utils/toast";

function Basic() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { resetPasswordLoading } = useSelector(state => state.auth);

    const [form, setForm] = useState({ email: "", token: "", password: "", confirmPassword: "" });
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (!form.token) {
            showToast("Please enter the verification code from your email.", TOAST_TYPE.error);
            return;
        }
        if (form.password !== form.confirmPassword) {
            showToast("Passwords do not match.", TOAST_TYPE.error);
            return;
        }
        await dispatch(actions.resetPassword(form));
        setTimeout(() => navigate("/auth/login"), 2000);
    };

    return (
        <BasicLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="primary"
                    borderRadius="lg"
                    coloredShadow="success"
                    mx={2}
                    mt={-3}
                    py={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Reset Password
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={4}>
                            <MDInput onChange={handleChange} name="email" type="email" label="Email" variant="standard" fullWidth />
                        </MDBox>
                        <MDBox mb={4}>
                            <MDInput onChange={handleChange} name="token" type="text" label="Verification Code (from email)" variant="standard" fullWidth />
                        </MDBox>
                        <MDBox mb={4}>
                            <MDInput onChange={handleChange} name="password" type={showPassword ? "text" : "password"} label="New Password" variant="standard" fullWidth />
                        </MDBox>
                        <MDBox mb={4}>
                            <MDInput onChange={handleChange} name="confirmPassword" type={showPassword ? "text" : "password"} label="Confirm Password" variant="standard" fullWidth />
                        </MDBox>
                        <MDBox display="flex" alignItems="center" ml={-1} mb={2}>
                            <Switch checked={showPassword} onChange={() => setShowPassword(!showPassword)} />
                            <MDTypography variant="button" fontWeight="regular" color="text" sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                                &nbsp;&nbsp;Show Password
                            </MDTypography>
                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton onClick={handleSubmit} disabled={resetPasswordLoading} variant="gradient" color="primary" fullWidth>
                                {resetPasswordLoading ? "Changing password…" : "Change Password"}
                            </MDButton>
                        </MDBox>
                        <MDBox mt={2} textAlign="center">
                            <MDTypography component={Link} to="/auth/login" variant="button" color="primary" fontWeight="medium">
                                Back to Sign In
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </BasicLayout>
    );
}

export default Basic;
